module.exports = __webpack_public_path__ + "img/mission_error_icon.4267a6e7.svg";